// extracted by mini-css-extract-plugin
export var intro = "intro-two-module--intro--FzjYP";
export var intro__second = "intro-two-module--intro__second--kOl8z";
export var intro__wrap = "intro-two-module--intro__wrap--16ymU";
export var intro__section = "intro-two-module--intro__section--3zNS-";
export var intro__section__image = "intro-two-module--intro__section__image--1gL1N";
export var info__section__image__bg = "intro-two-module--info__section__image__bg--14-ix";
export var intro__section__image__bg = "intro-two-module--intro__section__image__bg--1D88b";